import { t } from 'i18next';
import { useContext, useMemo, useState } from 'react';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

import FilesPageContext from '../../FilesPageContext';
import FilesQueryContext from '../../FilesQueryContext';
import DownloadFilesDialog from '../DownloadFilesDialog/DownloadFilesDialog';

export default function BulkDownloadFilesCTA() {
  const { checkedJobIds } = useContext(FilesPageContext);
  const { filters } = useContext(FilesQueryContext);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const hasTargetedFiltersApplied = Object.values(filters).some((filter) => {
    if (Array.isArray(filter)) {
      return filter.length > 0;
    }

    return Boolean(filter);
  });

  const shouldEnableCTA = useMemo(() => {
    if (checkedJobIds.length > 0) {
      return false;
    }

    return hasTargetedFiltersApplied;
  }, [checkedJobIds.length, hasTargetedFiltersApplied]);

  const pageFilter = useMemo(
    () => ({
      customerAccountIds: filters.customerAccountIds,
      dispatchNumberIds: filters.dispatchNumberIds,
      driverIds: filters.driverIds,
      dropoffSiteIds: filters.dropoffSiteIds,
      endDate: filters.endDate,
      foremanIds: filters.foremanIds,
      jobStates: filters.jobStates,
      pickupSiteIds: filters.pickupSiteIds,
      projectIds: filters.projectIds,
      startDate: filters.startDate,
      vendorAccountIds: filters.vendorAccountIds,
    }),
    [
      filters.customerAccountIds,
      filters.dispatchNumberIds,
      filters.driverIds,
      filters.dropoffSiteIds,
      filters.endDate,
      filters.foremanIds,
      filters.jobStates,
      filters.pickupSiteIds,
      filters.projectIds,
      filters.startDate,
      filters.vendorAccountIds,
    ],
  );

  return (
    <>
      <SmallButton
        color="inherit"
        disabled={!shouldEnableCTA}
        onClick={() => setIsDialogOpen(true)}
        sx={(theme) => ({ border: `solid 1px ${theme.brandV2.colors.treadGray7}` })}
        variant="outlined"
      >
        {t('approvals.files.bulk_download_files_cta')}
      </SmallButton>

      <DownloadFilesDialog
        isOpen={isDialogOpen}
        pageFilter={pageFilter}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
}
